import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'
import { goToMultiStepDialogStep } from '@agtech/web/components/Portals/Dialogs/AgTechMultiStepFormDialog'

// Each step moves the dialog to the page that holds its target, so the tour can walk through all
// three pages. Moving this way skips step validation; nothing is created until Create Invoice is clicked.
export const InvoiceCreationDialogTourConfig: AgTechTourConfig = {
    id: 'invoice-creation-dialog-tour',
    name: 'Create Invoice Tour',
    steps: [
        {
            targetId: 'multistep-dialog-step-panel',
            title: 'Invoice Steps',
            description: 'Invoice creation is split into 3 steps. Complete each in order using Next and Back. The dots on the left track your progress.',
            position: 'right',
            onActivate: () => goToMultiStepDialogStep(0),
        },
        {
            targetId: 'invoice-create-general',
            title: 'Bidder and Contact',
            description: 'Confirm who is being invoiced. Use the link in the section header to open the full contact record.',
            position: 'bottom',
            onActivate: () => goToMultiStepDialogStep(0),
        },
        {
            targetId: 'invoice-create-lots',
            title: 'Lots Purchased',
            description: 'Choose which lots to include. All lots this bidder purchased that are not yet invoiced are pre-selected; uncheck any that belong on a separate invoice.',
            position: 'top',
            onActivate: () => goToMultiStepDialogStep(0),
        },
        {
            targetId: 'invoice-create-modifiers',
            title: 'Charges and Discounts',
            description: 'Select the sale-level charges (like fees) and discounts to apply. Use the add button in the section header to create a new one without leaving the dialog.',
            position: 'bottom',
            onActivate: () => goToMultiStepDialogStep(1),
        },
        {
            targetId: 'invoice-create-credits',
            title: 'Credits',
            description: 'Apply any credits this contact has on file to reduce the amount due. Use the add button to create a new credit.',
            position: 'top',
            onActivate: () => goToMultiStepDialogStep(1),
        },
        {
            targetId: 'invoice-create-summary',
            title: 'Invoice Summary',
            description: 'Lots sold, less charges and discounts, less credits applied, equals the invoice amount. Check that it looks right before creating the invoice.',
            position: 'bottom',
            onActivate: () => goToMultiStepDialogStep(2),
        },
        {
            targetId: 'invoice-create-review-lots',
            title: 'Review and Create',
            description: 'A read-only list of the lots on this invoice. When everything looks correct, click Create Invoice. Use Back to change anything.',
            position: 'top',
            onActivate: () => goToMultiStepDialogStep(2),
        },
    ]
}
